import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/starIcon.svg'
import _imports_1 from '@/assets/images/ND-hero.webp'
import _imports_2 from '@/assets/images/dentist.webp'


const _hoisted_1 = { class: "landing-page-hero" }
const _hoisted_2 = { class: "landing-page-hero-text-wrapper" }
const _hoisted_3 = { class: "landing-page-hero-text" }
const _hoisted_4 = { class: "landing-page-hero-text-title" }
const _hoisted_5 = { class: "landing-page-hero-text-box" }
const _hoisted_6 = { class: "body-text" }
const _hoisted_7 = { class: "body-text" }
const _hoisted_8 = { class: "landing-page-services" }
const _hoisted_9 = { class: "section-title" }
const _hoisted_10 = {
  key: 0,
  class: "landing-page-services-box"
}
const _hoisted_11 = { class: "title-text" }
const _hoisted_12 = { class: "landing-page-services-box-item-description" }
const _hoisted_13 = { class: "services-box" }
const _hoisted_14 = { class: "title-text" }
const _hoisted_15 = { class: "services-box-description" }
const _hoisted_16 = { class: "grey-box" }
const _hoisted_17 = { class: "landing-page-about" }
const _hoisted_18 = { class: "landing-page-about-info" }
const _hoisted_19 = { class: "section-title" }
const _hoisted_20 = { class: "body-text" }
const _hoisted_21 = { class: "landing-page-products" }
const _hoisted_22 = { class: "section-title" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "product-item-title" }
const _hoisted_25 = { class: "title-text" }
const _hoisted_26 = { class: "body-text" }
const _hoisted_27 = { class: "body-text-bold" }
const _hoisted_28 = { class: "landing-page-location" }
const _hoisted_29 = { class: "landing-page-location-wrapper" }
const _hoisted_30 = { class: "landing-page-location-info" }
const _hoisted_31 = { class: "landing-page-location-info-box" }
const _hoisted_32 = { class: "body-text-bold" }
const _hoisted_33 = {
  href: "https://maps.app.goo.gl/u5G23RqsfHufE8YD6",
  target: "_blank",
  class: "landing-page-location-info-box-row"
}
const _hoisted_34 = { class: "link-text" }
const _hoisted_35 = { class: "landing-page-location-info-box" }
const _hoisted_36 = { class: "body-text-bold" }
const _hoisted_37 = { class: "body-text" }
const _hoisted_38 = { class: "body-text" }
const _hoisted_39 = { class: "landing-page-location-info-box" }
const _hoisted_40 = { class: "body-text-bold" }

import SwiperComponent from '@/components/SwiperComponent.vue';
import ContactForm from '@/components/ContactForm.vue';
import { onMounted, useTemplateRef, watch } from 'vue';
import { Loader } from '@googlemaps/js-api-loader';
import { generalStore } from '@/store';
import __ from '@/translate';


export default /*@__PURE__*/_defineComponent({
  __name: 'LandingPage',
  setup(__props) {

const services = [
  {
    title: 'service_option_prevention',
    description: [
      'service_option_prevention',
      'service_option_first_examination',
      'service_option_check_up',
      'service_option_tartar_cleaning',
      'service_option_prevention_children',
    ],
  },
  {
    title: 'service_option_fillers',
    description: ['service_option_composite_fillings', 'service_option_aesthetic_composite_fillings'],
  },
  {
    title: 'service_option_rtg',
    description: [
      'service_option_opg',
      'service_option_bitewing_radiographs',
      'service_option_local_radiographs',
      'service_option_3d_cbct',
    ],
  },
  {
    title: 'service_option_prosthetics',
    description: [
      'service_option_veneers',
      'service_option_partial_crowns',
      'service_option_full_crowns',
      'service_option_bonding',
      'service_option_removable_prosthetics',
    ],
  },
  {
    title: 'service_option_teeth_whitening',
    description: ['service_option_safe_teeth_whitening'],
  },
  {
    title: 'service_option_surgery_and_implantology',
    description: ['service_option_apicotomy'],
  },
  {
    title: 'service_option_endodontic_treatment',
    description: [
      'service_option_root_canal_treatment',
      'service_option_magnification',
      'service_option_rubber_membrane',
      'service_option_machine_expansion',
      'service_option_ultrasound',
    ],
  },
];

let map: google.maps.Map | null = null;
const mapElement = useTemplateRef('mapElement');
const store = generalStore();

let mobileOptions: google.maps.MapOptions;
let desktopOptions: google.maps.MapOptions;

onMounted(async () => {
  // axios.put('api/translations/si', 'daviid2', {
  //   headers: {
  //     'Content-Type': 'application/json',
  //   },
  // });

  await Promise.all([store.fetchProducts()]);
  const loader = new Loader({
    apiKey: 'AIzaSyDiP-0e-uI9Xkup13OeE-Lo3dL_QzbCIZE',
    version: 'weekly',
  });

  if (!mapElement.value) {
    return;
  }

  const { Map } = (await loader.importLibrary('maps')) as google.maps.MapsLibrary;
  const { AdvancedMarkerElement } = (await loader.importLibrary('marker')) as google.maps.MarkerLibrary;
  mobileOptions = {
    zoomControlOptions: {
      position: google.maps.ControlPosition.TOP_RIGHT,
    },
    center: { lat: 46.1855757, lng: 14.4910531 },
  };

  desktopOptions = {
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_BOTTOM,
    },
    center: { lat: 46.1871757, lng: 14.4874782 },
  };

  map = new Map(mapElement.value, {
    ...(store.isMobile ? mobileOptions : desktopOptions),
    mapId: '6896da82777ebb1f',
    zoom: 17,
    disableDefaultUI: true,
    gestureHandling: 'cooperative',
    clickableIcons: false,
    fullscreenControl: false,
    fullscreenControlOptions: null,
    keyboardShortcuts: null,
    streetView: null,
    streetViewControl: false,
    streetViewControlOptions: null,
    scrollwheel: false,
    zoomControl: true,
  });

  new AdvancedMarkerElement({
    map,
    position: {
      lat: 46.1871757,
      lng: 14.4910531,
    },
    title: 'Nordic Dental',
    content: new DOMParser().parseFromString(
      '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="77" viewBox="0 0 54 77" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M27 76.334C27 76.334 53.5 47.9356 53.5 27.7784C53.5 12.6213 41.6355 0.333984 27 0.333984C12.3645 0.333984 0.5 12.6213 0.5 27.7784C0.5 47.9356 27 76.334 27 76.334Z" fill="#15BBBD"/><path d="M32.1605 32.125C27.5015 36.136 26.9491 44.6131 26.9491 44.6131L26.9251 44.3617C26.817 42.9968 26.0365 35.7529 21.8338 32.113C17.1748 28.1019 10.5586 27.0005 10.5586 27.0005C10.5586 27.0005 17.1748 25.9109 21.8338 21.8878C26.0485 18.2599 26.817 11.0041 26.9251 9.63912L26.9491 9.3877C26.9491 9.3877 27.5015 17.8648 32.1605 21.8758C36.8195 25.8869 43.4357 26.9885 43.4357 26.9885C43.4357 26.9885 36.8195 28.1139 32.1605 32.125Z" fill="white"/></svg>',
      'image/svg+xml'
    ).documentElement,
    zIndex: 20000,
  });
});

watch(
  () => store.isMobile,
  (val) => {
    if (val) {
      map?.setOptions(mobileOptions);
    } else {
      map?.setOptions(desktopOptions);
    }
  }
);

function formatWorkingHours(hours: number) {
  const hoursString = hours.toString();
  const hoursLength = hoursString.length;
  return `${hoursString.length === 3 ? '0' : ''}${hoursString.slice(0, hoursLength - 2)}:${hoursString.slice(
    hoursLength - 2
  )}`;
}

const dayMap: Record<number, string> = {
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday',
  7: 'sunday',
};

const workingHours = {
  '1': {
    start: 1030,
    end: 1930,
  },
  '2': {
    start: 1030,
    end: 1900,
  },
  '3': {
    start: 730,
    end: 1300,
  },
  '4': {
    start: 730,
    end: 1230,
  },
  '5': {
    start: 730,
    end: 1200,
  },
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(__)('landing_title')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(__)('landing_subtitle')), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(__)('landing_second_subtitle')), 1)
          ]),
          _createVNode(_component_router_link, {
            to: {
            name: 'LandingPage',
            hash: '#contact',
          },
            class: "button"
          }, {
            default: _withCtx(() => [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_unref(__)('landing_button')), 1)
            ]),
            _: 1,
            __: [0]
          })
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_1,
        class: "landing-page-hero-image"
      }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(__)('services_title')), 1),
      (!_unref(store).isMobile && !_unref(store).isTablet)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (service) => {
              return _createElementVNode("div", {
                class: "landing-page-services-box-item",
                key: service.title
              }, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(__)(service.title)), 1),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border-space-breaker" }, null, -1)),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.description, (description, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "body-text",
                      key: index
                    }, _toDisplayString(_unref(__)(description)), 1))
                  }), 128))
                ])
              ])
            }), 64))
          ]))
        : (_openBlock(), _createBlock(SwiperComponent, {
            key: 1,
            items: services,
            "children-class": ".services-box"
          }, {
            item: _withCtx(({ item }) => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(__)(item.title)), 1),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "border-space-breaker" }, null, -1)),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.description, (description, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "body-text",
                      key: index
                    }, _toDisplayString(_unref(__)(description)), 1))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }))
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "landing-page-about-image" }, [
          _createElementVNode("img", { src: _imports_2 })
        ], -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(__)('dentist_title')), 1),
          _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(__)('dentist_description')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(__)('products_title')), 1),
      _createVNode(SwiperComponent, {
        items: _unref(store).products,
        "children-class": ".product-item"
      }, {
        item: _withCtx(({ item }) => [
          _createVNode(_component_router_link, {
            to: { name: 'ProductDetails', params: { id: item.id } },
            class: "product-item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item.imageUrl
              }, null, 8, _hoisted_23),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(item.name), 1),
                _createElementVNode("p", _hoisted_26, _toDisplayString(item.description), 1)
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "border-space-breaker" }, null, -1)),
              _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(store).formatPrice(item.price)), 1)
            ]),
            _: 2,
            __: [5]
          }, 1032, ["to"])
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", {
        id: "map",
        class: "map",
        ref_key: "mapElement",
        ref: mapElement
      }, null, 512),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("p", _hoisted_32, _toDisplayString(_unref(__)('location_title')), 1),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "body-text" }, "Kopitarjev trg 1, 1217 Vodice", -1)),
            _createElementVNode("a", _hoisted_33, [
              _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(__)('location_action')), 1),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "arrow right-arrow" }, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(__)('working_hours')), 1),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(workingHours, (day, index) => {
              return _createElementVNode("div", {
                class: "landing-page-location-info-box-hours",
                key: index
              }, [
                _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(__)(dayMap[Number(index)])), 1),
                _createElementVNode("p", _hoisted_38, _toDisplayString(formatWorkingHours(day.start)) + " - " + _toDisplayString(formatWorkingHours(day.end)), 1)
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(__)('contact_title')), 1),
            _cache[8] || (_cache[8] = _createElementVNode("a", {
              href: "tel:01 777 41 04",
              class: "body-text"
            }, "01 777 41 04", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("a", {
              href: "mailto:info@nordic-dental.si",
              class: "body-text",
              target: "_blank"
            }, "info@nordic-dental.si", -1))
          ])
        ])
      ])
    ]),
    _createVNode(ContactForm)
  ], 64))
}
}

})